import { APIFieldType } from './apiTypes';
import { ReportColumn, ReportColumnType } from './reportAPITypes';

const isDateColumn = ({ dataType, isDateRangeColumn }: ReportColumn) =>
  (dataType === APIFieldType.DATE_TIME ||
    dataType === APIFieldType.DATE_ONLY) &&
  !isDateRangeColumn;

const isCheckBoxColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.CHECKBOX;

const isDateRangeColumn = ({ isDateRangeColumn }: ReportColumn) =>
  isDateRangeColumn;

const isUserColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.USER;

const isTextColumn = ({ dataType, key }: ReportColumn) =>
  dataType === APIFieldType.TEXT &&
  !['parent', 'source', 'target'].includes(key);

const isTextAreaColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.TEXT_AREA;

const isNumberColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.NUMBER;

const isNameColumn = ({ key }: ReportColumn) => key === 'name';

const isParentColumn = ({ key }: ReportColumn) => key === 'parent';

const isSourceColumn = ({ key }: ReportColumn) => key === 'source';

const isTargetColumn = ({ key }: ReportColumn) => key === 'target';

const isURLColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.URL;

const isEmailColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.EMAIL;

const isReferenceColumn = ({ type }: ReportColumn) =>
  type === ReportColumnType.REFERENCE_TYPE_INCOMING ||
  type === ReportColumnType.REFERENCE_TYPE_OUTGOING;

const isListColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.LIST;

const isSelectMultipleListColumn = ({ dataType }: ReportColumn) =>
  dataType === APIFieldType.SELECT_MULTIPLE_LIST;

const isTypeColumn = ({ key }: ReportColumn) =>
  key === 'type' || key === 'typeId';

const isWorkspaceColumn = ({ key }: ReportColumn) => key === 'rootWorkspace';

const isArdoqOID = ({ key }: ReportColumn) => key === '_id';

export const columnPredicates = {
  isDateColumn,
  isCheckBoxColumn,
  isDateRangeColumn,
  isUserColumn,
  isTextColumn,
  isTextAreaColumn,
  isNumberColumn,
  isNameColumn,
  isParentColumn,
  isSourceColumn,
  isTargetColumn,
  isReferenceColumn,
  isURLColumn,
  isEmailColumn,
  isListColumn,
  isSelectMultipleListColumn,
  isTypeColumn,
  isWorkspaceColumn,
  isArdoqOID,
};
